import { render, staticRenderFns } from "./SettingsNavItem.vue?vue&type=template&id=f6af3f00&scoped=true&"
import script from "./SettingsNavItem.vue?vue&type=script&lang=ts&"
export * from "./SettingsNavItem.vue?vue&type=script&lang=ts&"
import style0 from "./SettingsNavItem.vue?vue&type=style&index=0&id=f6af3f00&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6af3f00",
  null
  
)

export default component.exports